<mat-card>
    <mat-card-header>
        <mat-card-title>Decision</mat-card-title>
    </mat-card-header>
    <mat-card-content class="m-t-1">
         <app-select-input [label]="'What type of visa was ' + (isAppealCancel ? 'cancelled' : 'refused') + '?'"
            [control]="decisionForm.controls.visaType" [visaTypes]="visaTypes" shortLabel="Visa Type" placeholder="Select a Visa Type">
        </app-select-input>
         <app-select-input [label]="'Who made the decision?'"
            [control]="decisionForm.controls.whoMadeDecision" [lookupItems]="appealDecisionBy" shortLabel="Decision Maker" placeholder="Select a Decision Maker">
        </app-select-input>
        <app-date-input [label]="'What was the date of the decision?'"
            [control]="decisionForm.controls.decisionDate" shortLabel="Decision Date">
        </app-date-input>
        <app-select-input [label]="'How did you receive this notification?'"
            [control]="decisionForm.controls.notifiedBy" [lookupItems]="notifiedBy" shortLabel="Notification Method" placeholder="Select a Notification Method">
        </app-select-input>
        <app-date-input [label]="'What date did you receive this notification?'"
            [control]="decisionForm.controls.notifiedDate" shortLabel="Notification Date"> 
        </app-date-input>
          <app-file-upload
            [label]="'Please attach a copy of the decision here (if available) by clicking the button below'"
            (change)="onFileUploaded($event)"
            placeholder="Upload a file"
            uploadType="decision"
            [displayValue]="model.decision?.decisionFile?.[0]?.name || ''"
            >
        </app-file-upload>
        <app-text-area [label]="'Why do you think the decision is incorrect and why do you want to appeal?'" 
        [control]="decisionForm.controls.whyAppeal" 
        shortLabel="Reason for Appeal">
        </app-text-area>
    </mat-card-content>
</mat-card>
